// extracted by mini-css-extract-plugin
export var category = "_je-9";
export var categoryHeader = "_je-e";
export var container = "_je-0";
export var group = "_je-a";
export var groupItems = "_je-f";
export var groupSeparator = "_je-j";
export var loading = "_je-1";
export var noResults = "_je-3";
export var placeholder = "_je-2";
export var resultContent = "_je-5";
export var resultIcon = "_je-c";
export var resultItem = "_je-g";
export var resultMeta = "_je-8";
export var resultSubtitle = "_je-7";
export var resultSuffix = "_je-i";
export var resultTitle = "_je-6";
export var resultsList = "_je-4";
export var searchGroup = "_je-d";
export var selected = "_je-h";
export var subgroup = "_je-b";